import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/isi";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllIsiByTax(params.tratamientoId);
}

export function IsiList(props) {
  const [isiList, setIsi] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllIsiByTax(props.id).then(setIsi).catch(console.log);
  }, [props.id]);
  return (
    <>
      {isiList?.length ? (
            <ul className="isi cpt-list">
              {isiList.map((isi) => (
                <li key={isi.id}>
                  <NavLink to={`${props.id}/cuestionarios/isi/${isi.id}`}>{`${FormatDate(isi.meta.isiFecha)}`}</NavLink>
                </li>
              ))}
            </ul>
          ) : (
            <></>
          )}
    </>
  );
}



export function IsiListContent() {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>Isi</h1>
      </div>
      <div id="actions">
        {<Link className="button is-link" to={`new`}>Nuevo</Link>}
      </div>
    </>
  );
}